import { Stack, Typography, useTheme } from "@mui/material";
import { FileText } from "lucide-react";
import type { FC } from "react";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { IconBox } from "web_myplann/Shared/Components/IconBox";

type Props = {
	fileName: string;
	backgroundColor: string;
	color?: string;
	boxShadow?: string;
};

export const ChatAttachmentFile: FC<Props> = ({
	fileName,
	backgroundColor,
	color,
	boxShadow,
}) => {
	const theme = useTheme();
	const { t } = useResource();

	return (
		<Stack
			direction="row"
			alignItems="center"
			gap={0.6}
			px={1.2}
			py={0.8}
			maxWidth="100%"
			borderRadius={theme.radii.xl}
			bgcolor={backgroundColor}
			boxShadow={boxShadow}
		>
			<IconBox
				bg={theme.palette.red[50]}
				size={32}
				borderRadius={theme.radii.md}
			>
				<FileText size={theme.iconSize.sm} color={theme.palette.red[500]} />
			</IconBox>
			<Stack minWidth={0}>
				<Typography variant="bodyMedium" noWrap color={color}>
					{fileName}
				</Typography>
				<Typography variant="hint" color={color}>
					{t(Resources.Chat.attachmentFile)}
				</Typography>
			</Stack>
		</Stack>
	);
};
